<template>
  <div class="main_wrapper">
    <div class="cover_image_wrapper">
      <h2 class="cover_title">{{ $t('portal.agriculture_news') }}</h2>
      <img src="../../../assets/images/portal/cover-img.jpg" alt="" />
    </div>
    <div class="breadcrumb_wrapper">
      <b-container>
        <b-row>
          <b-col>
            <nav aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/portal/home">{{ $t('portal.home') }}</router-link></li>
                <li class="breadcrumb-item"><router-link to="/portal/news">{{ $t('portal.agriculture_news') }}</router-link></li>
                <li class="breadcrumb-item active"><a to="#">{{ $t('portal.news_details') }}</a></li>
              </ol>
            </nav>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div class="menu_bar_wrapper">
      <b-container>
        <b-row>
          <b-col sm="8">
            <div class="main_wrapper">
              <div class="news_item news_details_wrapper">
                <b-card no-body class="overflow-hidden">
                  <b-row no-gutters>
                    <b-col>
                      <div v-if="loading">
                        <loadNews />
                      </div>
                      <b-card-body v-else style="padding: 1.15rem">
                          <b-card-title>
                            {{ ($i18n.locale == 'bn') ? news.title_bn : news.title }}
                          </b-card-title>
                        <b-card-text>
                          <div v-if="userLoad">
                            <b-skeleton animation="wave" width="100%"></b-skeleton>
                          </div>
                          <div v-else class="timeline">
                            <span><i class="fas fa-user-circle"></i> {{ checkBn ? user(news.user_id).name_bn : user(news.user_id).name }}</span>
                                <!-- <span><i class="fas fa-map-marker-alt"></i> জামালগঞ্জ, সুনামগঞ্জ</span> -->
                            <span><i class="fas fa-calendar-alt"></i> {{ news.created_at | dateFormat }}</span>
                          </div>
                          <div>
                            <div class="cover_img">
                              <img :src="commonServiceBaseUrl + 'download-attachment?file=uploads/portaloriginal/' + news.image_bn" class="img-fluid rounded-0" alt="" />
                            </div>
                            <h4 class="heading_title">{{ ($i18n.locale == 'bn') ? news.title_bn : news.title }}</h4>
                            <p class="mb-0">
                              {{ ($i18n.locale == 'bn') ? news.description_bn : news.description }}
                            </p>
                          </div>
                        </b-card-text>
                      </b-card-body>
                    </b-col>
                    </b-row>
                  </b-card>
              </div>
            </div>
          </b-col>
          <b-col sm="4">
            <div class="museum_wrapper mt-4">
              <div class="portal_header">
                <h6 class="title">
                  <i class="fas fa-globe-europe"></i> {{ $t('portal.popular_agriculture_news') }}
                </h6>
              </div>
              <div v-if="newsLoading">
                <Popular/>
              </div>
              <div v-else class="sidebar_quick_item quick_news_wrapper">
                <ul>
                  <li v-for="(news, index) in newsList.slice(0, 10)" :key="index"><router-link :to="'/portal/news-details/' + news.id">{{ checkBn ? news.title_bn : news.title }}</router-link></li>
                </ul>
              </div>
            </div>
            <div style="margin-top: 20px">
              <img src="../../../assets/images/portal/help-line-bg.png" class="img-fluid" alt="" />
            </div>
          </b-col>
        </b-row>
      </b-container>
    </div>
  </div>
</template>
<script>
import RestApi, { authServiceBaseUrl, commonServiceBaseUrl } from '../../../config/api_config'
import loadNews from '../components/home/loading/news/details'
import Popular from '../components/home/loading/news/popular'

export default {
  components: {
    loadNews,
    Popular
  },
  created () {
    this.loadData()
    this.loadPopular()
  },
  data () {
    return {
      loading: false,
      commonServiceBaseUrl: commonServiceBaseUrl,
      newsLoading: false,
      news: {},
      newsList: [],
      userLoad: false,
      users: []
    }
  },
  methods: {
    user (id) {
      return this.users.find(item => item.id === parseInt(id))
    },
    async loadData () {
      this.loading = true
      const result = await RestApi.getData(commonServiceBaseUrl, '/portal/frontend/news/show', { id: this.$route.params.id })
      this.loading = false
      if (result.success) {
        this.news = result.data
        this.loadUser([result.data.user_id])
      }
    },
    async loadPopular () {
      this.newsLoading = true
      const result = await RestApi.getData(commonServiceBaseUrl, '/portal/frontend/news/popular')
      this.newsLoading = false
      if (result.success) {
        this.newsList = result.data
      }
    },
    async loadUser (users) {
      this.userLoad = true
      const result = await RestApi.getData(authServiceBaseUrl, '/auth/portal/get-users', { user_ids: JSON.stringify(users) })
      this.userLoad = false
      if (result.success) {
       this.users = result.data
      }
    }
  }
}
</script>
